module.exports = __webpack_public_path__ + "static/img/open-app-bg.1b0383e7.png";